<div class="container single-view" id="view-item">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/items" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'ITEMS.BTN_BACK_TO_ITEM' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-baseline justify-between gap-4">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="product-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'ITEM_SINGLE_VIEW.ITEM_DETAILS' | translate }}</h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                @if (item.product.name) {
                  <span data-testid="product-name">{{ item.product.name | defaultValue }}</span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="w-100 flex flex-wrap justify-between gap-y-4 self-end">
          <div id="complementary-details" class="flex flex-wrap">
            <span data-testid='item-producttype' class="flex items-center mr-2"
              pTooltip="{{ 'PRODUCT_SINGLE_VIEW.TOOLTIP_PRODUCT_TYPE' | translate }}" tooltipPosition="top"><i
                class="icon icon-product-types mr-1"></i>{{ item.product.productType.name | defaultValue }}</span>
            <span data-testid='item-collection' class="flex items-center mr-2"
              pTooltip="{{ 'PRODUCT_SINGLE_VIEW.TOOLTIP_PRODUCT_COLLECTION' | translate }}" tooltipPosition="top"><i
                class="icon icon-collections mr-1"></i>{{ item.product.collections | defaultValue
              }}</span>
            <span data-testid='item-collection' class="flex items-center mr-2"
              pTooltip="{{ 'PRODUCT_SINGLE_VIEW.TOOLTIP_PRODUCT_COLLECTION' | translate }}" tooltipPosition="top"><i
                class="icon icon-category mr-1"></i>{{ item.product.categories | defaultValue
              }}</span>
          </div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">
            @if (allowDigitalCard) {
              <button data-testid="item-digitalcard-btn" class="btn outline-btn" (click)="createDigitalCard()" [disabled]="item.disposition != 'SOLD' || !canCreateDigitalCard">
                {{ 'DIGITAL_CARDS.BTN_CREATE_DIGITAL_CARD' | translate }}
              </button>
            }

            @if (canDeclareTheft) {
              <button data-testid="item-theft-btn" class="btn red-btn" (click)="declareTheft()" [disabled]="itemIsStolen">
                {{ 'ITEMS.BTN_THEFT' | translate }}
              </button>
            }

            @if (canDeclareRecovery) {
              <button data-testid="item-recovered-btn" class="btn primary-btn" (click)="declareRecover()" [disabled]="!itemIsStolen">
                {{ 'ITEMS.BTN_RECOVER' | translate }}
              </button>
            }

            @if (allowModifyItem) {
              <button data-testid="item-edit-btn" class="btn primary-btn" (click)="goToEditItem()" [disabled]="!itemCanBeModified">
                {{ 'ITEM_SINGLE_VIEW.BTN_EDIT' | translate }}
              </button>
            }

            @if (delete) {
              <button data-testid="item-delete-btn" class="btn red-btn" (click)="showDeleteDialog()" [disabled]="itemIsStolen">
                {{ 'ITEMS.BTN_DELETE' | translate }}
              </button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <section class="row">
              <div class="col-12 col-sm-12 col-md-4 col-lg-3">
                <img data-testid='item-imageurl'
                  src="{{ item.productCustomisation?.imageUrl || item.product.imageUrl || item.product.productType.imageUrl }}"
                  class="w-100 mt-2 featured-image">
              </div>
              <div class="col-12 col-sm-12 col-md-8 col-lg-9">
                <h4 data-testid="item-details">{{ 'ITEM_SINGLE_VIEW.DETAILS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                <dl class="details-grid">

                  <dt data-testid='sale-brandname-label' class="label grid-cols-1 pt-3">{{ 'SALE_SINGLE_VIEW.BRAND' | translate }}</dt>
                  <dd data-testid='sale-brandname' class="value pt-3 pb-3">{{ item.product.brandName | defaultValue }}</dd>

                  @if (!item.product.isLimitedEdition) {
                    <dt data-testid='item-serialnumber-label' class="label grid-cols-1 pt-3">{{'ITEM_SINGLE_VIEW.SERIAL_NUMBER' | translate }}</dt>
                    <dd data-testid='item-serialnumber' class="value pt-3 pb-3">{{ item.serialNumber | defaultValue }}</dd>
                  }

                  <dt data-testid='product-sku-label' class="label grid-cols-1 pt-3">{{ 'ITEM_SINGLE_VIEW.SKU' | translate }}</dt>
                  <dd data-testid='product-sku' class="value pt-3 pb-3">{{ item.product.sku | defaultValue }}</dd>

                  @if (item.product.isLimitedEdition) {
                    <dt data-testid='item-islimitededition-label' class="label grid-cols-1 pt-3">{{'PRODUCT_SINGLE_VIEW.LIMITED_EDITION' | translate }}</dt>
                    <dd data-testid='item-islimitededition' class="value pt-3 pb-3">{{ item.product.isLimitedEdition |friendlyBoolean }}</dd>

                    <dt data-testid='item-serialnumber-label' class="label grid-cols-1 pt-3">{{'SALE_CREATE.LIMITED_EDITION_NUMBER' | translate }}</dt>
                    <dd data-testid='item-serialnumber' class="value pt-3 pb-3">{{ item.serialNumber | defaultValue }}</dd>

                    <dt data-testid='item-limitededitionsize-label' class="label grid-cols-1 pt-3">{{'PRODUCT_SINGLE_VIEW.TOTAL_EDITION_UNITS' | translate }}</dt>
                    <dd data-testid='item-limitededitionsize' class="value pt-3 pb-3">{{item.product.limitedEditionSize | defaultValue }}</dd>
                  }

                  <dt data-testid='item-productiondate-label' class="label grid-cols-1 pt-3">{{'ITEM_SINGLE_VIEW.PRODUCTION_DATE' | translate }}</dt>
                  <dd data-testid='item-productiondate' class="value pt-3 pb-3">{{ item.productionDate | date:'dd-MM-yyyy HH:mm' | defaultValue }}</dd>

                  @if (showSecurityCodeField) {
                    <dt data-testid='item-securitycode-label' class="label grid-cols-1 pt-3">{{'ITEM_SINGLE_VIEW.SECURITY_CODE' | translate }}</dt>
                    <dd data-testid='item-securitycode' class="value pt-3 pb-3">{{ item.securityCode | defaultValue }}</dd>
                  }

                  @if (showSecurityCodeVersionField) {
                    <dt data-testid='item-securitycodeversion-label' class="label grid-cols-1 pt-3">{{'ITEM_SINGLE_VIEW.SECURITY_CODE_VERSION' | translate }}</dt>
                    <dd data-testid='item-securitycodeversion' class="value pt-3 pb-3">{{ item.securityCodeVersion |defaultValue }}</dd>
                  }

                  @if (companyHasCpo) {
                    <dt data-testid="item-iscpo-label" class="label grid-cols-1 pt-3">{{ 'ITEM_SINGLE_VIEW.REFURBISHED_CPO' | translate }}</dt>
                    <dd data-testid="item-iscpo" class="value pt-3 pb-3">{{ item!.isCpo | friendlyBoolean | defaultValue }}</dd>
                  }

                  <dt data-testid='item-isgenuine-label' class="label grid-cols-1 pt-3">{{'ITEM_SINGLE_VIEW.GENUINE_PRODUCT' | translate }}</dt>
                  <dd data-testid='item-isgenuine' class="value pt-3 pb-3">{{ item!.isGenuine | friendlyBoolean }}</dd>
                </dl>
              </div>
            </section>
            <section class="row">
              <div class="col-12 mb-3">
                <h4 data-testid='item-operations-details'>{{ 'ITEM_SINGLE_VIEW.OPERATIONS_HISTORY' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
              </div>
              <div class="col-12">
                <p-table data-testid='item-operations' [value]="itemOperationsData"
                  [paginator]="itemOperationsData?.length > itemOperationsRows" [rows]="itemOperationsRows">
                  <ng-template #header>
                    <tr>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'ITEM_SINGLE_VIEW.OPERATION_DATE' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'ITEM_SINGLE_VIEW.OPERATION_TYPE' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'ITEM_SINGLE_VIEW.DURATION_IN_MONTHS' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'ITEM_SINGLE_VIEW.WARRANTY_ID' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'ITEM_SINGLE_VIEW.CREATED_ON' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'ITEM_SINGLE_VIEW.CREATED_BY' | translate }}</span>
                        </div>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-warrantyOperation>
                    <tr>
                      <td>
                        <span class="p-column-title">{{ 'ITEM_SINGLE_VIEW.OPERATION_DATE' | translate }}:</span>
                        {{ warrantyOperation.operation.operationDate | date: 'dd-MM-yyyy HH:mm' | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'ITEM_SINGLE_VIEW.OPERATION_TYPE' | translate }}:</span>
                        {{ warrantyOperation.operation.warrantyOperationType | warrantyOperationTypePipe | defaultValue
                        }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'ITEM_SINGLE_VIEW.DURATION_IN_MONTHS' | translate }}:</span>
                        {{ warrantyOperation.operation.durationInMonths || ('ITEM_SINGLE_VIEW.NOT_AVAILABLE' |
                        translate) }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'ITEM_SINGLE_VIEW.WARRANTY_ID' | translate }}:</span>
                        <a [routerLink]="['/warranties/', warrantyOperation.warrantyId]" class="inline-flex items-center link">{{ warrantyOperation.code | defaultValue }}</a>
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'ITEM_SINGLE_VIEW.CREATED_ON' | translate }}:</span>
                        {{ warrantyOperation.operation.createdOn | date: 'dd-MM-yyyy HH:mm' | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'ITEM_SINGLE_VIEW.CREATED_BY' | translate }}:</span>
                        <a [routerLink]="['/users/', warrantyOperation.operation.createdById]" class="inline-flex items-center link">
                          {{ warrantyOperation.operation.createdByFullName | defaultValue }}
                        </a>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template #emptymessage>
                    <tr>
                      <td colspan="6">{{ 'ITEM_SINGLE_VIEW.NO_OPEARATIONS_DATA' | translate }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </section>
            <section class="row">
              <div class="col-12 mb-3">
                <h4 data-testid='item-events-details'>{{ 'ITEM_SINGLE_VIEW.OPERATIONS_EVENTS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
              </div>
              <div class="col-12">
                <p-table data-testid='item-events' [value]="itemEventsData"
                  [paginator]="itemEventsData?.length > itemEventsRows" [rows]="itemEventsRows">
                  <ng-template #header>
                    <tr>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'ITEM_SINGLE_VIEW.EVENT_DATE' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'ITEM_SINGLE_VIEW.EVENT_TYPE' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'ITEM_SINGLE_VIEW.EVENT_STATE' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'ITEM_SINGLE_VIEW.EVENT_DISPOSITION' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'ITEM_SINGLE_VIEW.EVENT_RELATED' | translate }}</span>
                        </div>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-event>
                    <tr>
                      <td>
                        <span class="p-column-title">{{ 'ITEM_SINGLE_VIEW.EVENT_DATE' | translate }}:</span>
                        {{ event.eventTime | date: 'dd-MM-yyyy HH:mm' | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'ITEM_SINGLE_VIEW.EVENT_TYPE' | translate }}:</span>
                        {{ event.eventType | eventTypePipe | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'ITEM_SINGLE_VIEW.EVENT_STATE' | translate }}:</span>
                        {{ event.newState | itemStatePipe | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'ITEM_SINGLE_VIEW.EVENT_DISPOSITION' | translate }}:</span>
                        {{ event.newDisposition | itemLocationPipe | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'ITEM_SINGLE_VIEW.EVENT_RELATED' | translate }}:</span>
                        @if ((event.eventType == 'SELLING' || event.eventType == 'RETURNING') && canViewSales) {
                          <a [routerLink]="['/sales/', event.relatedId]" class="inline-flex items-center link">
                            <div class="flex justify-center">
                              <button type="button" pTooltip="{{ 'ITEMS.TOOLTIP_VIEW_DETAILS' | translate }}" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-eye">
                                <span class="btn-label">{{ 'ITEMS.VIEW_ITEM_DETAILS' | translate }}</span>
                              </button>
                            </div>
                          </a>
                        } @else if (event.eventType == 'REPAIRING' && canViewWarranties) {
                          <a [routerLink]="['/warranties/', event.relatedId]" class="inline-flex items-center link">
                            <div class="flex justify-center">
                              <button type="button" pTooltip="{{ 'ITEMS.TOOLTIP_VIEW_DETAILS' | translate }}" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-eye">
                                <span class="btn-label">{{ 'ITEMS.VIEW_ITEM_DETAILS' | translate }}</span>
                              </button>
                            </div>
                          </a>
                        } @else if (event.eventType == 'SHIPPING' && canViewShipments) {
                          <a [routerLink]="['/shipments/', event.relatedId]" class="inline-flex items-center link">
                            <div class="flex justify-center">
                              <button type="button" pTooltip="{{ 'ITEMS.TOOLTIP_VIEW_DETAILS' | translate }}" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-eye">
                                <span class="btn-label">{{ 'ITEMS.VIEW_ITEM_DETAILS' | translate }}</span>
                              </button>
                            </div>
                          </a>
                        } @else if (event.eventType == 'STORING' && event.relatedId && canViewInventories) {
                          <a [routerLink]="['/inventories/', event.relatedId]" class="inline-flex items-center link">
                            <div class="flex justify-center">
                              <button type="button" pTooltip="{{ 'ITEMS.TOOLTIP_VIEW_DETAILS' | translate }}" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-eye">
                                <span class="btn-label">{{ 'ITEMS.VIEW_ITEM_DETAILS' | translate }}</span>
                              </button>
                            </div>
                          </a>
                        } @else {
                          <span [attr.data-event]="event.eventType ?? 'unknown'">-</span>
                        }
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template #emptymessage>
                    <tr>
                      <td colspan="6">{{ 'ITEM_SINGLE_VIEW.NO_OPEARATIONS_DATA' | translate }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </section>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modalbox: declare theft -->
<p-dialog [header]="'MODALBOXES.TITLE_DECLARE_THEFT' | translate" [(visible)]="displayDeclareTheftModalbox" [modal]="true" (onHide)="onHideDeclareTheftAction()" [blockScroll]="true" [draggable]="false" [resizable]="false" [closable]="true" class="compact-modal">
  <form [formGroup]="declareTheftForm" class="mt-0">
      <div class="field-wr col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <label data-testid='declare-theft-retailer-label' class="block text-sm" for="retailers-selection">{{ 'WARRANTY_ACTIVATION.SEARCH_RETAILER' | translate }} <i class="icon-required-field"></i></label>
        <app-custom-dropdown
          data-testid="retailer"
          [placeholder]="'WARRANTY_ACTIVATION.SELECT_RETAILER_PLACEHOLDER' | translate"
          optionLabel="text"
          optionValue="id"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="false"
          [searchMode]="'remote'"
          [pageSize]="storesRowsPerPageOption"
          [totalCount]="storesTotalRecords"
          [totalPages]="getTotalPages(storesTotalRecords, storesRowsPerPageOption)"
          [options]="storesList"
          formControlName="retailerId"
          (onLazyLoad)="onLazyLoadStores($event)">
        </app-custom-dropdown>
      </div>
    <div class="field-wr flex flex-col col-12">
      <label data-testid="theft-reason-label" class="block text-sm" for="reason">{{ 'MODALBOXES.REASON' | translate
        }}</label>
      <input data-testid="theft-reason-input" type="text" formControlName="reason" autocomplete="off">
    </div>
  </form>
  <ng-template #footer>
    <button data-testid="cancel-theft-btn" type="button" class="btn outline-btn" (click)="onCancelTheftModal()">
      {{ 'MODALBOXES.BTN_CANCEL' | translate }}
    </button>
    <button data-testid="declare-theft-btn" type="submit" class="btn primary-btn" [disabled]="declareTheftForm.invalid"
      (click)="onSubmitTheftForm()">
      {{ 'MODALBOXES.BTN_CONFIRM' | translate }}
    </button>
  </ng-template>
</p-dialog>

<!-- Modalbox: declare recover -->
<p-dialog [header]="'MODALBOXES.TITLE_DECLARE_RECOVERED' | translate" [(visible)]="displayDeclareRecoveredModalbox" [modal]="true" (onHide)="onHideDeclareRecoveredAction()" [blockScroll]="true" [draggable]="false" [resizable]="false" [closable]="true" class="compact-modal">
  <form [formGroup]="declareRecoveredForm" class="mt-0">
    <div class="field-wr col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <label data-testid='recover-retailer-label' class="block text-sm" for="retailers-selection">{{ 'WARRANTY_ACTIVATION.SEARCH_RETAILER' | translate }} <i class="icon-required-field"></i></label>
        <app-custom-dropdown
          data-testid="retailer"
          [placeholder]="'WARRANTY_ACTIVATION.SELECT_RETAILER_PLACEHOLDER' | translate"
          optionLabel="text"
          optionValue="id"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="false"
          [searchMode]="'remote'"
          [pageSize]="storesRowsPerPageOption"
          [totalCount]="storesTotalRecords"
          [totalPages]="getTotalPages(storesTotalRecords, storesRowsPerPageOption)"
          [options]="storesList"
          formControlName="retailerId"
          (onLazyLoad)="onLazyLoadStores($event)">
        </app-custom-dropdown>
      </div>
    <div class="field-wr flex flex-col col-12">
      <label data-testid="recover-reason-label" class="block text-sm" for="reason">{{ 'MODALBOXES.REASON' | translate
        }} <i class="icon-required-field"></i></label>
      <input data-testid="recover-reason-input" type="text" formControlName="reason" autocomplete="off">
      @if (
        declareRecoveredForm.get('reason')?.invalid &&
        (declareRecoveredForm.get('reason')?.dirty || declareRecoveredForm.get('reason')?.touched)
      ) {
        @if (declareRecoveredForm.get('reason')?.hasError('required')) {
          <small data-testid="recover-mandatory" class="p-error">
            {{ 'MODALBOXES.REASON_REQUIRED' | translate }}
          </small>
        }
      }
    </div>
  </form>
  <ng-template #footer>
    <button data-testid="cancel-recover-btn" type="button" class="btn outline-btn" (click)="onCancelRecoverModal()">
      {{ 'MODALBOXES.BTN_CANCEL' | translate }}
    </button>
    <button data-testid="declare-recover-btn" type="submit" class="btn primary-btn"
      [disabled]="declareRecoveredForm.invalid" (click)="onSubmitRecoverForm()">
      {{ 'MODALBOXES.BTN_CONFIRM' | translate }}
    </button>
  </ng-template>
</p-dialog>

<!-- Delete item -->
<dialog-reason #dialog [title]="'MODALBOXES.TITLE_CONFIRM_DELETE_ITEM'" (onClose)="deleteItem($event)"></dialog-reason>
